import { IExperiment } from '../../api/experiments';

export const feedbackExperimentName = 'feedback';

export enum EGroup {
  aGroup = 0,
  bGroup,
  cGroup,
}

export function getGroup(experiments: IExperiment[]) {
  const feedbackExperiment = experiments.find(experiment => experiment.name === feedbackExperimentName);

  return feedbackExperiment ? feedbackExperiment.abGroup : EGroup.aGroup;
}
